import { createBrowserRouter } from 'react-router';
import { RedirectIfAuthenticated, RequireAuth } from '@/auth';
import { EuProvider } from '@/features/notas/EuContext';
import { AppLayout } from '@/layouts/AppLayout';
import { AuthLayout } from '@/layouts/AuthLayout';
import { AdminPage } from '@/pages/AdminPage';
import { ComoFuncionaPage } from '@/pages/ComoFuncionaPage';
import { ConfirmarPage } from '@/pages/ConfirmarPage';
import { DisciplinaPage } from '@/pages/DisciplinaPage';
import { LoginPage } from '@/pages/auth/LoginPage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { PainelPage } from '@/pages/PainelPage';
import { PreferenciasPage } from '@/pages/PreferenciasPage';
import { VincularPage } from '@/pages/VincularPage';

/**
 * Públicas: login e a confirmação pelo link do e-mail (pode ser aberta no celular, sem sessão).
 * Privadas: tudo dentro de <EuProvider>, que manda quem ainda não confirmou o RA para /vincular.
 */
export const router = createBrowserRouter([
  {
    element: (
      <RedirectIfAuthenticated>
        <AuthLayout />
      </RedirectIfAuthenticated>
    ),
    children: [{ path: '/login', element: <LoginPage /> }],
  },
  {
    element: <AuthLayout />,
    children: [
      { path: '/confirmar', element: <ConfirmarPage /> },
      { path: '/preferencias', element: <PreferenciasPage /> },
    ],
  },
  {
    element: (
      <RequireAuth>
        <EuProvider>
          <AppLayout />
        </EuProvider>
      </RequireAuth>
    ),
    children: [
      { index: true, path: '/', element: <PainelPage /> },
      { path: '/disciplina/:codigo', element: <DisciplinaPage /> },
      { path: '/vincular', element: <VincularPage /> },
      { path: '/como-funciona', element: <ComoFuncionaPage /> },
      { path: '/admin', element: <AdminPage /> },
      { path: '/admin/aluno/:ra', element: <PainelPage /> },
      { path: '/admin/aluno/:ra/disciplina/:codigo', element: <DisciplinaPage /> },
    ],
  },
  { path: '*', element: <NotFoundPage /> },
]);
